require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/core-js/library/fn/array/from.js
// module id = 638
// module chunks = 168707334958949